module.exports = __webpack_public_path__ + "static/media/FillerupIcon.8b933312.svg";